<div class="wizard flex flex-col h-full">
    <!-- Header (all steps) + step-2 info & recommended-topics row, on a tinted band. -->
    <div class="wizard-band" [class.wizard-band--topics]="!isScanning() && !scanFailed() && step() === wizardStep.TOPICS">
        <div class="wizard-header flex items-center justify-between">
            <h2 class="wizard-title">Topic Selection Wizard</h2>
            <button matButton="text" type="button" class="back-to-main" (click)="onBack()">
                <fa-icon class="si-icon mr-1" [icon]="['fal', 'arrow-u-turn-up-left']"></fa-icon>
                Back to main
            </button>
        </div>

        @if (!isScanning() && !scanFailed() && step() === wizardStep.TOPICS) {
            <p class="wizard-topics-desc">
                The following topics may be a good match for your business. Add any or all, up to your account
                limits. Topics you've previously selected for your account are also shown.
            </p>
            <div class="wizard-rec-row flex items-center justify-between">
                <h4 class="font-bold flex items-center mb-0">
                    <span>Recommended Topics by Category ({{ displayTopics | intentDataTopicCount | number }})</span>
                    <span class="a font-normal ml-4" (click)="onAddAllRecommended()">Add all</span>
                    <span class="a font-normal ml-3" (click)="onRemoveAllRecommended()">Remove all</span>
                </h4>
                <span class="whitespace-nowrap pr-4">Max selections: {{ planPropertyValues?.maxTopics | number }}</span>
            </div>
        }
    </div>

    <div class="wizard-body grow flex flex-col min-h-0">
        @if (isScanning()) {
            <section class="h-full flex flex-col justify-center items-center text-center">
                <mat-spinner [diameter]="56"></mat-spinner>
                <p class="scan-title">Scanning {{ scanningDomain }}...</p>
                <p class="scan-subtitle">{{ currentLoaderMessage() }}</p>
            </section>
        } @else if (scanFailed()) {
            <section class="h-full flex flex-col justify-center items-center text-center">
                <p class="font-extrabold">We don't have any signals to recommend for this website. Please try again.</p>
                <button matButton="filled" type="button" (click)="onTryAgain()">
                    Try Again
                </button>
            </section>
        } @else if (step() === wizardStep.DOMAIN) {
            <form
                [formGroup]="domainForm"
                (ngSubmit)="onContinue()"
                class="wizard-form"
            >
                <p class="mt-2 mb-4">
                    Provide your business domain. Our intelligence will scan your domain and make in-market topic
                    recommendations for your account. This scan may take up to a minute.
                </p>

                <mat-form-field appearance="outline" class="mb-2 w-full">
                    <mat-label>Company Website</mat-label>
                    <input #companyWebsiteInput matInput type="text" formControlName="companyWebsite" name="companyWebsite"
                        placeholder="example.com or https://example.com" />
                    @if (domainForm.get('companyWebsite')?.hasError('invalidDomain')) {
                        <mat-error>
                            Please provide a valid website.
                        </mat-error>
                    }
                </mat-form-field>

                <div class="pt-2 flex justify-end">
                    <button matButton="filled" type="submit" [disabled]="domainForm.invalid">
                        Continue
                    </button>
                </div>
            </form>
        } @else if (step() === wizardStep.TOPICS) {
            <app-intent
                class="wizard-selector"
                [source]="source"
                [plans]="plans"
                [planPropertyValues]="planPropertyValues"
                [topics]="displayTopics"
                [accountTopics]="workingTopics"
                [isLoading]="false"
                [recommendationMode]="true"
                (listChange)="onWorkingTopicsChange($event)"
            ></app-intent>
        }
    </div>
</div>
